<template>
  <div v-if="canManageIFrames" class="column box">
    <div class="title" :class="{'has-text-centered': $route.name === 'manageIFrames'}">IFrames</div>
    <div class="control">
      <div class="box" style="">
        <div class="iframe-table">
            <label class="label">
              Show Iframe Details for Event: &nbsp;
              <select v-model="allEvents" id="show_partner" @change="eventSelected" name="show_partner" :placeholder="'Select event'">
                <option :value="null" disabled>Select event</option>
                <option class="option" v-for="event in events" :key="event.id" :value="event">{{ event.name }}</option>
              </select>
            </label>
        </div>

          <div class="display-list ">
            <div class="list-title" v-if="eventIframes.length>0">
              Click on the item in the Route or Url to edit and then click on the Action button:
            </div>
            <div v-for="(eventIframe, index) in eventIframes" :key="eventIframe.id" class="tableBox ">
              <div v-if="index === 0" class="tableHeaderRow">
                <div class="tableHeaderElement bold iframe-column-route border">Route</div>
                <div class="tableHeaderElement bold iframe-column-url border">Url</div>
                <div class="tableHeaderElement bold iframe-column-meta-info border">MetaInfo</div>
                <div class="tableHeaderElement bold iframe-column-action border"> Action</div>
              </div>

              <div class="tableBodyRow">
                <div v-if="eventIframe.route" class="tableHeaderElement iframe-column-route border">
                  <li>
                    <input v-if="editInput[index].route[0].edit"
                      v-model="eventIframe.route"
                      @blur="editInput[index].route[0].edit=false; $emit('update');"
                      @keyup.enter="editInput[index].route[0].edit=false; $emit('update'); "
                      v-focus="editInput[index].route[0].edit"
                    >
                    <div v-else>
                      <label @click = "editInput[index].route[0].edit = true;"> {{ eventIframe.route }} </label>
                    </div>
                  </li>
                </div>

                <div v-if="eventIframe.url" class="tableHeaderElement iframe-column-url border">
                  <li>
                    <input v-if="editInput[index].url[0].edit"
                      v-model="eventIframe.url"
                      @blur="editInput[index].url[0].edit = false; $emit('update');"
                      @keyup.enter="editInput[index].url[0].edit = false; $emit('update'); "
                      v-focus="editInput[index].url[0].edit"
                    >
                    <div v-else>
                      <label @click="editInput[index].url[0].edit = true;"> {{ eventIframe.url }} </label>
                    </div>
                  </li>
                </div>
                <div v-if="eventIframe.metaInfo" class="tableHeaderElement iframe-column-meta-info border">
                  <li>
                    <input v-if="editInput[index].metaInfo[0].edit"
                      v-model="eventIframe.metaInfo"
                      @blur="editInput[index].metaInfo[0].edit = false; $emit('update');"
                      @keyup.enter="editInput[index].metaInfo[0].edit = false; $emit('update'); "
                      v-focus="editInput[index].metaInfo[0].edit"
                    >
                    <div v-else>
                      <label @click="editInput[index].metaInfo[0].edit = true;"> {{ eventIframe.metaInfo }} </label>
                    </div>
                  </li>
                </div>
                <div class="tableHeaderElement iframe-column-action border">
                  <button class="iframeLink" @click="updateIframe(eventIframe, index)">Update</button>
                  <button class="iframeLink" @click="deleteIframe(eventIframe, index)">Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box bottom top">
          <div class="iframe-table">
            <span class="bold">Add Iframe</span>
          </div>

          <div class="display-list">
            <generic-dropdown :id="'events'" v-model="selectedEvent" :items="events" placeholder="Select Event"></generic-dropdown>
            <generic-input v-model="addRoute" input type="text" placeholder="Route"></generic-input>
            <generic-input v-model="addUrl" input type="text" placeholder="Url"></generic-input>
            <generic-input v-model="addMetaInfo" input type="text" placeholder="MetaInfo"></generic-input>
            <button class="button is-primary" @click="addIframe(selectedEvent.id, addRoute, addUrl, addMetaInfo)">Add</button>
          </div>
        </div>
        <span class="title help is-info" v-if="infoMessage">{{infoMessage}}</span>
        <span class="title help is-danger" v-if="errorMessage">{{errorMessage}}</span>
    </div>
  </div>
</template>

<script>
import iframeApi from '@/api/iframe'

import GenericInput from '@/components/Controls/GenericComponents/input'
import GenericDropdown from '@/components/Controls/GenericComponents/dropdown'

import auth from '@/mixins/auth'

export default {
  name: 'adminRegionalUsers',
  mixins: [auth],
  components: {
    GenericDropdown,
    GenericInput
  },
  data: function () {
    return {
      allEvents: null,
      allEventsList: null,
      addRoute: null,
      addUrl: null,
      addMetaInfo: null,
      selectedEvent: null,
      eventIframes: [],
      editInput: [{ route: [], url: [], metaInfo: [] }],
      infoMessage: '',
      errorMessage: ''
    }
  },
  mounted: function () {
    if (!this.canManageIFrames) {
      this.$router.push({ name: 'notFound' })
    } else {
      this.getEvents()
    }
  },
  computed: {
    canManageIFrames: function () {
      return this.isLoggedIn && (this.isAdmin || this.currentUser.isIFrameManager)
    },
    getInputLength: function (inputData) {
      return inputData.length
    },
    events: function () {
      return this.$store.getters.events
    }
  },
  methods: {
    getEvents: function () {
      this.$store.dispatch('getEvents').then((response) => {
      }, (error) => {
        this.errorMessage = error.message
      })
    },
    eventSelected: function () {
      this.selectEventID = this.allEvents?.id
      this.clearMessages()
      this.getIframesForEvent()
    },
    getIframesForEvent: function () {
      iframeApi.getIframes(this.selectEventID).then((response) => {
        this.eventIframes = response.data.result.iframes

        for (let i = 0; i < this.eventIframes.length; i++) {
          if (i > 0) {
            this.editInput.push({ route: [], url: [], metaInfo: [] })
          }
          this.editInput[i].route.push({ edit: false })
          this.editInput[i].url.push({ edit: false })
          this.editInput[i].metaInfo.push({ edit: false })
        }
      }, (error) => {
        this.errorMessage = error
      })
    },
    addIframe: function (eventId, route, url, metaInfo) {
      this.clearMessages()
      const data = {
        eventID: eventId,
        route: route,
        url: url,
        metaInfo: metaInfo
      }
      iframeApi.addIframe(data).then((response) => {
        this.infoMessage = 'Iframe created successfully'
        if (eventId === this.selectEventID) {
          const newIframe = response.data.result.iframe
          this.eventIframes.push(newIframe)
          this.editInput.push({ route: [newIframe.route], url: [newIframe.url], metaInfo: [newIframe.metaInfo] })
        }
        this.resetAddIframe()
      }, (error) => {
        this.errorMessage = error
      })
    },
    updateIframe: function (iframe, index) {
      this.clearMessages()
      const data = {
        route: iframe.route,
        url: iframe.url,
        metaInfo: iframe.metaInfo
      }
      iframeApi.updateIframe(iframe.id, data).then((response) => {
        this.infoMessage = 'Iframe successfully updated'
        const updatedIframe = response.data.result.iframe
        this.eventIframes[index].route = updatedIframe.route
        this.eventIframes[index].url = updatedIframe.url
        this.eventIframes[index].metaInfo = updatedIframe.metaInfo
      }, (error) => {
        this.errorMessage = error
        this.getIframesForEvent()
      })
    },
    deleteIframe: function (iframe, index) {
      this.clearMessages()
      iframeApi.deleteIframe(iframe.id).then(() => {
        this.infoMessage = 'Iframe successfully deleted'
        this.eventIframes.splice(index, 1)
      }, (error) => {
        this.errorMessage = error
      })
    },
    clearMessages: function () {
      this.infoMessage = ''
      this.errorMessage = ''
    },
    resetAddIframe: function () {
      this.addRoute = ''
      this.addUrl = ''
      this.selectedEvent = null
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  }
}
</script>

<style scoped>
li {
    list-style-type: none;
}
label {
  padding-bottom: 0px;
  margin-bottom: 0px;
}
input {
  font-size: 1em;
  width: 100%;
}
.bold {
  font-weight: bold;
}
.box {
  margin-bottom: 0;
}
select#show_partner, select#add_partner, button.iframeLink {
  font-size: 1em;
}
.addIframeHeader {
  width: 33%;
}
.addIframeHeaderPartner {
  width: 26%;
}
.addIframeHeaderAction {
  width: 8%;
}
.iframeLink {
  cursor: pointer;
}
.iframe-column-route {
  width: 20%;
  padding: 0 0.5rem;
}
.iframe-column-url {
  width: 45%;
  padding: 0 0.5rem;
}
.iframe-column-meta-info{
  width: 15%;
}
.iframe-column-action {
  width: 20%;
  padding: 0 0.5rem;
}
.iframe-table {
    float: left;
    padding: 0.5rem;
}
.border {
    border: 1px solid silver;
}
.top {
  margin-top: 3.5rem;
}
.bottom {
    padding-bottom: 1rem;
}
.display-list {
  margin-top: 3rem;
}
.tableHeaderRow {
  margin-bottom: 2px;
  overflow: hidden;
}
.tableBodyRow {
  overflow: hidden;
  margin-bottom: 2px;
}
.add-iframe {
  display: flex;
  flex-direction: column;
}
.tableBox {
  width: 100%;
}
.tableHeaderElement {
  float: left;
  margin-bottom: 0;
  padding: 1rem;
  padding: 0 0.5rem;
}
.message, .addMessage {
  height: 2rem;
  width: 100%;
  float: right;
  padding-right: 0.5rem;
  font-weight: bold;
  color: red;
  font-size: 15px;
  text-align: right;
  background-color: white;
  margin-top: 0.5rem;
}
.list-title {
  font-weight: bold;
  font-style: italic;
  padding: 5px 0 15px 8px;
}
</style>
